import PositionSettings from "./position";
import ContentSettings from "./content";
import FontSettings from "./font";
import { ContentWrapper, AccordionWrapper, SettingsAccordion } from "./styled";
import BackgroundSettings from "./background";
import SizeSettings from "./size";
import BorderSettings from "./border";

const Appearance = () => {
  return (
    <ContentWrapper>
      <AccordionWrapper>
        <SettingsAccordion
          alwaysOpen
          defaultActiveKey={["0", "1", "2", "3", "4"]}
        >
          <ContentSettings />
          <PositionSettings />
          <SizeSettings />
          <BorderSettings />
          <FontSettings />
          <BackgroundSettings />
        </SettingsAccordion>
      </AccordionWrapper>
    </ContentWrapper>
  );
};

export default Appearance;
